import { i18n } from '@/plugins/i18n'

export const customerStatus = {
    PENDING:    true,
    PUBLISHED:  false,
};

export const customerStatusStr = {
    PENDING:    i18n.t('online-factor.archive') ,
    PUBLISHED:  i18n.t('online-factor.active') ,

    get(status) {
        let status_str = null;

        Object.keys(customerStatus).forEach(item => {
            if(customerStatus[item] === status) {
                status_str = customerStatusStr[item];
            }
        });

        return status_str;
    }
};

export const customerStatusVariant = (status) => {
    if(status === customerStatus.PUBLISHED) {
        return 'success';
    }

    if(status === customerStatus.PENDING) {
        return 'warning';
    }

    return 'secondary';
};
